var _linearGradient, _path, _linearGradient2, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhotoshop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2458,
    viewBox: "0 0 300 295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: -973.025,
    y1: 1430.582,
    x2: -858.025,
    y2: 1187.581,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1415.176)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0cbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#a0cbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    stopColor: "#8ec2fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#83bcfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fbafb"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h300v295H0z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: -932.205,
    y1: 1388.221,
    x2: -867.205,
    y2: 1172.219,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1415.176)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#090058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070033"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M23.859 23.459h252.284v248.082H23.859z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: -1008.793,
    y1: 1417.652,
    x2: -893.794,
    y2: 1174.654,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1415.176)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0cbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#a0cbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    stopColor: "#8ec2fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#83bcfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fbafb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.498 83.144s18.968-.499 34.582-.499c15.778 0 27.028 3.712 34.581 10.235 7.219 6.164 12.087 16.672 12.087 28.634s-3.694 21.75-10.41 28.632c-8.729 8.881-18.901 14.138-36.258 14.865-4.795.201-9.233.249-9.233.249v38.884h-25.35l.001-121zm25.348 60.573c2.754.268 4.48.139 8.562.09 13.598-.163 21.989-8.432 21.989-20.937 0-11.234-6.919-20.458-19.973-20.936-5.203-.19-10.578 0-10.578 0v41.783z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: -943.289,
    y1: 1449.381,
    x2: -827.834,
    y2: 1205.42,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1415.176)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0cbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#a0cbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    stopColor: "#8ec2fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#83bcfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fbafb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.422 177.055c5.109 3.135 17.165 7.83 25.383 7.83 8.396 0 11.863-2.959 11.863-7.572 0-4.619-2.738-9.471-13.145-12.979-18.439-6.279-25.56-13.795-25.375-24.315 0-16.991 14.238-29.731 36.328-29.731 10.406 0 18.719 3.402 24.191 6.17v20.392c-4.02-2.218-15.611-7.17-23.277-7.17-6.759 0-10.59 2.77-10.59 7.382 0 4.248 3.471 6.464 14.424 10.344 16.975 5.908 24.096 14.584 24.276 27.879 0 16.805-12.954 30.168-38.7 29.357-8.836-.278-18.625-3.771-25.38-7.459l.002-20.128z",
    fill: "url(#d)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoshop);
export default __webpack_public_path__ + "static/media/photoshop.20d9ef589107ec250f77a9cc59d8d1b2.svg";
export { ForwardRef as ReactComponent };